import { useState, useEffect } from "react";
import { autenticazione, database } from "../firebase/config";
import { useAuthContext } from "./useAuthContext";

export const useLogin = () => {
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    setError(null);
    setIsPending(true);

    // sign the user in
    try {
      const res = await autenticazione.signInWithEmailAndPassword(
        email,
        password
      );
      //dispatch login action (subito, per non bloccare il reindirizzamento)
      dispatch({ type: "LOGIN", payload: res.user });
      // aggiornare status online (best-effort: non deve bloccare il login)
      database
        .collection("users")
        .doc(res.user.uid)
        .update({ online: true })
        .catch((err) => console.log(err.message));
      if (!isCancelled) {
        setIsPending(false);
        setError(null);
      }
    } catch (err) {
      if (!isCancelled) {
        console.log(err.message);
        setError(err.message);
        setIsPending(false);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { login, error, isPending };
};
